import { apiClient } from "../lib/api";

export const healthCommitteeApi = {
  getConfig: () => apiClient.get("/health-committee/config"),
  updateConfig: (establishment_status, note) => apiClient.put("/health-committee/config", { establishment_status, note }),

  listMembers: (activeOnly) => apiClient.get("/health-committee/members", { params: activeOnly ? { active_only: true } : {} }),
  addMember: (payload) => apiClient.post("/health-committee/members", payload),
  updateMember: (memberId, payload) => apiClient.patch(`/health-committee/members/${memberId}`, payload),

  listMeetings: (params) => apiClient.get("/health-committee/meetings", { params }),
  getMeeting: (meetingId) => apiClient.get(`/health-committee/meetings/${meetingId}`),
  createMeeting: (payload) => apiClient.post("/health-committee/meetings", payload),
  updateMeeting: (meetingId, payload) => apiClient.patch(`/health-committee/meetings/${meetingId}`, payload),
  submitMeeting: (meetingId) => apiClient.post(`/health-committee/meetings/${meetingId}/submit`),
  approveMeeting: (meetingId) => apiClient.post(`/health-committee/meetings/${meetingId}/approve`),
  finalizeMeeting: (meetingId) => apiClient.post(`/health-committee/meetings/${meetingId}/finalize`),
  reopenMeeting: (meetingId, reason) => apiClient.post(`/health-committee/meetings/${meetingId}/reopen`, { reason }),
  cancelMeeting: (meetingId, reason) => apiClient.post(`/health-committee/meetings/${meetingId}/cancel`, { reason }),

  listActionItems: (params) => apiClient.get("/health-committee/actions", { params }),
  createActionItem: (meetingId, payload) => apiClient.post(`/health-committee/meetings/${meetingId}/actions`, payload),
  updateActionItem: (itemId, payload) => apiClient.patch(`/health-committee/actions/${itemId}`, payload),
};
